export default __webpack_public_path__ + "static/media/ScreenShot_2.d4691e1b.jpg";